import { Button } from "@material-ui/core";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import Modal from "../../components/dialog/Modal";
import ScrollableTabs from "../../components/tabs/Tabs";
import { getTargetGroups } from "../../state/actions/TargetGroupActions";
import { ModelType } from "../../state/constants/ModelType";
import GenericPicker from "../generic-picker/GenericPicker";
import { withTranslation } from "react-i18next";

class TargetGroupPickerModal extends React.Component {
    constructor() {
        super();

        this.state = {
            selection: []
        }
    }

    render() {
        let { selection } = this.state;
        const handleSelection = newSelection => {
            this.setState({ selection: selection.concat(newSelection.filter((item) => selection.indexOf(item) < 0)) });
        };

        const customers = this.props.targetGroups.Customers != null ? this.props.targetGroups.Customers : {}
        const products = this.props.targetGroups.Products != null ? this.props.targetGroups.Products : {}

        return (
            <Modal
                title={this.props.t('target-group.target-groups')}
                open={this.props.open}
                fullWidth={true}
                fixedHeight={true}
                actions={
                    <div>
                        <Button color="secondary" onClick={this.props.handleCancel}>
                            {this.props.t('common.cancel')}
                        </Button>
                        <Button
                            color="secondary"
                            onClick={() => {
                                this.props.handleDone(selection);
                                this.setState({ selection: [] });
                            }}
                        >
                            {this.props.t('common.done')}
                        </Button>
                    </div>
                }
            >
                <ScrollableTabs
                    isSticky
                    tabs={
                        [
                            {
                                name: this.props.t('customer.customers'),
                                content: <GenericPicker
                                    selected={this.props.selected}
                                    handleSelection={handleSelection}
                                    getAllData={(callback) => this.props.getTargetGroups(ModelType.CUSTOMERS, callback)}
                                    searchTitle={this.props.t('target-group.target-groups')}
                                    data={Object.values(customers)}
                                    idField="id"
                                    valueField="DisplayName"
                                    currentSelection={selection}
                                />
                            },
                            {
                                name: this.props.t('product.products'),
                                content: <GenericPicker
                                    selected={this.props.selected}
                                    handleSelection={handleSelection}
                                    getAllData={(callback) => this.props.getTargetGroups(ModelType.PRODUCTS, callback)}
                                    searchTitle={this.props.t('target-group.target-groups')}
                                    data={Object.values(products)}
                                    idField="id"
                                    valueField="DisplayName"
                                    currentSelection={selection}
                                />
                            }
                        ]
                    } />
            </Modal>
        );
    }
}

// CONFIGURE REACT REDUX
const mapStateToProps = state => {
    const { targetGroups } = state.TargetGroupReducer
    return { targetGroups };
};

const mapDispatchToProps = dispatch => bindActionCreators({
    getTargetGroups
}, dispatch);

const hoc = withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(withTranslation()(TargetGroupPickerModal))
);

// EXPORT COMPONENT

export { hoc as TargetGroupPickerModal };

